import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useFeatureFlag } from 'switch-fe-shared/hooks/useFeatureFlag';

import { ACTIONS } from '../../../auth/utils/defineAbilityFor';
import { Can } from '../../../context/canContext';
import { useDynamicBrand } from '../../../context/DynamicBrandContext';

interface Props {
  onActivate?: () => void;
}

export default function BrandSettingsMenuItem({ onActivate }: Props) {
  const { setDrawerOpen } = useDynamicBrand();
  const isDemoBrandingEnabled = useFeatureFlag('ac_demo_dynamic_branding');

  if (!isDemoBrandingEnabled) return null;

  return (
    <Can I={ACTIONS.MANAGE} a='all'>
      <ListItemButton
        sx={{ borderRadius: 0 }}
        onClick={() => {
          setDrawerOpen(true);
          onActivate?.();
        }}
      >
        <ListItemIcon>
          <BrushOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary='Brand Settings' />
      </ListItemButton>
    </Can>
  );
}
